module.exports = __webpack_public_path__ + "img/index-scan-qrcode@3x.2bfda8a2.png";